const ErrorLabel = ({errorTitle , block = false,classesExtra=""})=>{
let classes = 'warning-';
classes+= block?'block':'inline';
return errorTitle != null || undefined ?<span className={classes +" " +classesExtra}>{errorTitle}</span>:'';
}
export default ErrorLabel;